module.exports = __webpack_public_path__ + "frontend/img/icon-rocket-xs.fbcf6b63.svg";